export const SITE_NAME = 'Clearlab';
export const SITE_URL = import.meta.env.VITE_SITE_URL ?? 'https://clearlab.com';
export const CONTACT_EMAIL = import.meta.env.VITE_CONTACT_EMAIL ?? 'enquiry@clearlab.com';
export const DEFAULT_DESCRIPTION =
  'Clearlab. Advancing vision science through proprietary contact-lens technologies.';

export interface PageSeo {
  title: string;
  description: string;
  path: string;
}

export const buildPageTitle = (title: string): string =>
  title === SITE_NAME ? SITE_NAME : `${title} | ${SITE_NAME}`;
